import type { TextKey } from '../i18n';
import { formatCurrency as companyMoney, formatNumber } from './format/currency';

/**
 * Mensaje para la respuesta 422 DAILY_LIMIT del API (tope diario de descuentos o refinanciaciones del
 * cobro). Devuelve null si el error es otro.
 */
export const dailyLimitMessage = (
  error: unknown,
  t: (k: TextKey, v?: Record<string, string | number>) => string,
): string | null => {
  const body = (error as any)?.response?.data;
  if (body?.code !== 'DAILY_LIMIT') return null;
  const fmt = (n: unknown) => (body.limit === 'refinance' ? formatNumber(Number(n || 0)) : companyMoney(Number(n || 0)));
  return t(body.limit === 'refinance' ? 'loans.dailyLimitRefinance' : body.limit === 'expense' ? 'loans.dailyLimitExpense' : 'loans.dailyLimitDiscount', {
    max: fmt(body.max),
    used: fmt(body.used),
  });
};
